export const error_message = {
  serverSide: "Error al intentar recuperar la información",
};
